import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#feeds', label: '猛料大厅' },
  { href: '#category', label: '热点分类' },
  { href: '#ranking', label: '热议榜' },
  { href: '#feature', label: '深度阅读' },
  { href: '#about', label: '关于我们' },
  { href: '#faq', label: '帮助 FAQ' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <nav className="flex items-center justify-between h-16 md:h-[72px]" aria-label="主导航">
          {/* 品牌 */}
          <a href="#home" className="flex items-center gap-2.5 shrink-0 cursor-pointer" aria-label="吃瓜热点 首页">
            <span className="flex w-9 h-9 md:w-10 md:h-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg md:text-xl" aria-hidden="true" />
            </span>
            <span className="font-heading font-black text-xl md:text-2xl tracking-tight text-foreground-950">
              吃瓜<span className="text-primary-600">热点</span>
            </span>
          </a>

          {/* 桌面导航 */}
          <ul className="hidden lg:flex items-center gap-1">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="px-4 py-2 rounded-md text-sm text-foreground-700 hover:text-primary-700 hover:bg-primary-50 transition whitespace-nowrap cursor-pointer"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="flex items-center gap-2.5">
            {/* 搜索 */}
            <form
              className="hidden md:flex items-center gap-2 rounded-full bg-background-100 border border-background-200 px-3.5 h-10 w-52"
              onSubmit={(e) => e.preventDefault()}
              role="search"
            >
              <i className="ri-search-line text-foreground-400 text-sm" aria-hidden="true" />
              <input
                type="search"
                placeholder="搜索热点 / 明星 / 事件"
                aria-label="搜索热点"
                className="bg-transparent outline-none text-sm text-foreground-800 placeholder:text-foreground-400 w-full"
              />
            </form>

            <a
              href="#contact"
              className="hidden sm:inline-flex items-center whitespace-nowrap gap-1.5 rounded-full bg-primary-500 text-background-50 px-4 md:px-5 py-2 text-sm font-medium hover:bg-primary-600 transition cursor-pointer"
            >
              <i className="ri-send-plane-line text-sm" aria-hidden="true" />
              投稿爆料
            </a>

            {/* 汉堡 */}
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label={open ? '关闭菜单' : '打开菜单'}
              aria-expanded={open}
              className="lg:hidden flex w-10 h-10 items-center justify-center rounded-lg text-foreground-700 hover:bg-background-200 cursor-pointer"
            >
              <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} aria-hidden="true" />
            </button>
          </div>
        </nav>
      </div>

      {/* 移动端面板 */}
      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-1">
            <form
              className="flex items-center gap-2 rounded-full bg-background-100 border border-background-200 px-3.5 h-10 mb-2"
              onSubmit={(e) => e.preventDefault()}
              role="search"
            >
              <i className="ri-search-line text-foreground-400 text-sm" aria-hidden="true" />
              <input
                type="search"
                placeholder="搜索热点 / 明星 / 事件"
                aria-label="搜索热点"
                className="bg-transparent outline-none text-sm text-foreground-800 placeholder:text-foreground-400 w-full"
              />
            </form>
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 rounded-md text-sm text-foreground-700 hover:text-primary-700 hover:bg-primary-50 cursor-pointer"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center whitespace-nowrap gap-1.5 rounded-full bg-primary-500 text-background-50 px-4 py-2.5 text-sm font-medium cursor-pointer"
            >
              <i className="ri-send-plane-line text-sm" aria-hidden="true" />
              投稿爆料
            </a>
          </div>
        </div>
      )}
    </header>
  );
}